import { useHistory } from 'react-router-dom';
import React, { useCallback, useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import { Alert } from '../../components/Alert/Alert';
import { H3 } from '../../components/H3/H3';
import { Header } from '../../components/Header/Header';
import { OrderSummary } from '../../components/OrderSummary/OrderSummary';
import { OverlaySpinner } from '../../components/OverlaySpinner/OverlaySpinner';
import { Status } from '../../types';
import { track } from '../../util';
import { useStore } from '../../store';
import * as api from '../../services/api';
import styles from './Payment.module.scss';
import { loadStripe } from '@stripe/stripe-js';
import { Elements, CardElement } from '@stripe/react-stripe-js';
import { Stripe } from '../../components/Stripe/Stripe';
import { Modal, Button } from 'react-bootstrap';
import { MIXPANEL_TOKEN, PAYMENT_FLOW_V1_ENABLED, BRAND_COLORS } from '../../config';
import swal from 'sweetalert';
import mixpanel from 'mixpanel-browser';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCreditCard } from '@fortawesome/free-solid-svg-icons';
import { faShieldHalved, faLock } from '@fortawesome/free-solid-svg-icons';

mixpanel.init(MIXPANEL_TOKEN, { debug: false });
const buttons = (window as any).paypal.Buttons;
const PayPalButton = buttons.driver('react', { React, ReactDOM });
const paypalStyle = { shape: 'pill', height: 50, label: 'checkout' };
const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY || '');

export function Payment() {
  const orderId = useStore((state) => state.orderId);
  const quotePrice = useStore((state) => state.quotePrice);
  const insuranceFee = useStore((state) => state.insuranceFee);
  const pickupEmail = useStore((state) => state.pickupEmail);
  const dropOffPOBox = useStore((state) => state.dropOffPOBox);
  const noPrinter = useStore((state) => state.noPrinter);
  const setCurrentStep = useStore((state) => state.setCurrentStep);
  const payPalPaymentGateway = useStore((state) => state.payPalPaymentGateway);
  const stripePaymentGateway = useStore((state) => state.stripePaymentGateway);
  const coinbasePaymentGateway = useStore((state) => state.coinbasePaymentGateway);
  const reCreateOrder = useStore((state) => state.reCreateOrder);
  const couponDiscountPercentage = useStore((state) => state.couponDiscountPercentage);
  const emails = useStore((state) => state.emails);
  const quoteInsurance = useStore((state) => state.quoteInsurance);
  const courierServiceName = useStore((s) => s.courierServiceName);
  const pickupFirstName = useStore((state) => state.pickupFirstName);
  const pickupLastName = useStore((state) => state.pickupLastName);
  const pickupCompanyName = useStore((state) => state.pickupCompanyName);
  const pickupAddress1 = useStore((state) => state.pickupAddress1);
  const pickupAddress2 = useStore((state) => state.pickupAddress2);
  const pickupSuburb = useStore((state) => state.pickupSuburb);
  const pickupState = useStore((state) => state.pickupState);
  const pickupPostcode = useStore((state) => state.pickupPostcode);
  const pickupPhone = useStore((state) => state.pickupPhone);
  const pickupBuildingType = useStore((state) => state.pickupBuildingType);
  const destinationFirstName = useStore((state) => state.destinationFirstName);
  const destinationLastName = useStore((state) => state.destinationLastName);
  const destinationCompanyName = useStore((state) => state.destinationCompanyName);
  const destinationEmail = useStore((state) => state.destinationEmail);
  const destinationAddress1 = useStore((state) => state.destinationAddress1);
  const destinationAddress2 = useStore((state) => state.destinationAddress2);
  const destinationSuburb = useStore((state) => state.destinationSuburb);
  const destinationState = useStore((state) => state.destinationState);
  const destinationPostcode = useStore((state) => state.destinationPostcode);
  const destinationPhone = useStore((state) => state.destinationPhone);
  const destinationBuildingType = useStore((state) => state.destinationBuildingType);
  const collectionDate = useStore((state) => state.collectionDate);
  const pickupTimeWindow = useStore((state) => state.pickupTimeWindow);
  const parcelContent = useStore((state) => state.parcelContent);
  const insuranceValue = useStore((state) => state.insuranceValue);
  const specialInstructions = useStore((state) => state.specialInstructions);
  const authorityToLeave = useStore((state) => state.authorityToLeave);
  const quoteExcludingGstPrice = useStore((state) => state.quoteExcludingGstPrice);
  const items = useStore((state) => state.items);

  const history = useHistory();
  const [status, setStatus] = useState<Status>('idle');
  const [errorMessage, setErrorMessage] = useState<string | null>(null);
  const [errors, setErrors] = useState<string[] | null>(null);
  const revenue: any = couponDiscountPercentage ?
    (
      (((quotePrice || 0) + (noPrinter ? 30 : 0) + Number(insuranceFee.replace('$', '')) - (Number(couponDiscountPercentage) / 100) * ((quotePrice || 0) + (noPrinter ? 30 : 0) + Number(insuranceFee.replace('$', '')))) * 0.1) + ((quotePrice || 0) + (noPrinter ? 30 : 0) + Number(insuranceFee.replace('$', '')) - (Number(couponDiscountPercentage) / 100) * ((quotePrice || 0) + (noPrinter ? 30 : 0) + Number(insuranceFee.replace('$', ''))))
    ).toFixed(2) :
    (
      (((quotePrice || 0) + (noPrinter ? 30 : 0) + Number(insuranceFee.replace('$', ''))) * 0.1) + (quotePrice || 0) + (noPrinter ? 30 : 0) + Number(insuranceFee.replace('$', ''))
    ).toFixed(2);

  const [show, setShow] = useState(false);
  const [isProcessingPayment, setIsProcessingPayment] = useState(false);

  const setReCreateOrder = useStore((state) => state.setReCreateOrder);
  const setOrderId = useStore((state) => state.setOrderId);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  let coinbaseCheckout = {
    height: '50px',
    fontSize: '21px',
    background: '#ECECEC',
    color: '#1a202c',
    font: "700 18px/1 'DM Sans', sans-serif",
  };

  interface ApiResponse {
    paypalOrderId?: string;
    orderId?: string;
  }

  interface ApiErrorResponse {
    message: string;
    errors?: Record<string, string[]>;
    type?: string;
  }

  // GTM GA4 Purchase Event helper
  const trackGTMPurchase = (paymentMethod: string) => {
    (window as any).dataLayer = (window as any).dataLayer || [];
    (window as any).dataLayer.push({
      event: 'purchase',
      ecommerce: {
        transaction_id: orderId || '',
        value: parseFloat(revenue) || 0,
        tax: parseFloat((parseFloat(revenue) / 11).toFixed(2)) || 0,
        currency: 'AUD',
        payment_type: paymentMethod,
        items: [{
          item_name: courierServiceName || 'Courier Service',
          item_id: orderId || '',
          price: parseFloat(revenue) || 0,
          quantity: 1
        }]
      }
    });
    console.log('[GTM Purchase] Event fired:', paymentMethod, 'Order:', orderId, 'Total: $' + revenue);
  };

  const createOrder = useCallback(async (): Promise<string | null> => {
    setStatus('in-progress');
    try {
      await api.csrf();

      const response: ApiResponse = PAYMENT_FLOW_V1_ENABLED
        ? await api.patch(`/v1/payment/order/${orderId}/prepare`, {})
        : await api.patch(`/order/${orderId}/prepare-payment`, {});

      // In new payment flow, backend returns `orderId`; in legacy flow, it returns `paypalOrderId`.
      const paypalOrderId = PAYMENT_FLOW_V1_ENABLED ? response.orderId : response.paypalOrderId;

      return paypalOrderId || null;
    } catch (e: any) {
      const errorResponse: ApiErrorResponse = e?.response?.data;

      if (errorResponse?.type === 'COURIER_PRECHECK') {
        setErrorMessage(errorResponse.message);
        const formattedErrors = errorResponse.errors ? Object.values(errorResponse.errors).flat() : null;
        setErrors(formattedErrors);
      }

      setStatus('error');
      return null;
    }
  }, [orderId]);

  const onApprove = useCallback(async () => {
    try {
      await api.csrf();
      const data = PAYMENT_FLOW_V1_ENABLED
        ? await api.patch<any>(`/v1/payment/order/${orderId}/paypal`, {})
        : await api.patch<any>(`/order/${orderId}/1/payment`, {});

      // If the endpoint returns a non-null for email, we should pass through the email, first name and last name
      const newUser = data.email ? btoa(JSON.stringify(data)) : '';
      const paypalEmail = data.paypalEmail ? data.paypalEmail : '';
      const jobNumber = data.jobNumber ? data.jobNumber : '';
      const consignmentNumber = data.consignmentNumber ? data.consignmentNumber : '';
      const labelPath = data.labelPath ? data.labelPath : '';
      const invoicePath = data.invoicePath ? data.invoicePath : '';

      history.push(`/order-complete?ref=${orderId}&new=${newUser}&label=${labelPath}&invoice=${invoicePath}`);
      let shipment_items: any = await setItemsForMixpanelPurchaseEvent(items);

      trackGTMPurchase('paypal');

      //tracking purchase on mixpanel
      mixpanel.track('Puchase', {
        'label': 'puchase',
        'platform_used': 'Website',
        'term_and_conditions': true,
        'payment_status': 'success',
        'payment_method': 'PayPal',
        'priceExcludingGst': quoteExcludingGstPrice,
        'priceIncludingGst': ((quotePrice || 0) + (quotePrice || 0) * 0.1).toFixed(2),
        'insuranceCategory': quoteInsurance,
        'courierServiceName': courierServiceName,
        'pickupAddress1': pickupAddress1,
        'pickupAddress2': pickupAddress2,
        'pickupFirstName': pickupFirstName,
        'pickupLastName': pickupLastName,
        'pickupEmail': pickupEmail,
        'pickupPhone': pickupPhone,
        'pickupSuburb': pickupSuburb,
        'pickupState': pickupState,
        'pickupPostcode': pickupPostcode,
        'pickupBuildingType': pickupBuildingType,
        'destinationAddress1': destinationAddress1,
        'destinationAddress2': destinationAddress2,
        'destinationFirstName': destinationFirstName,
        'destinationLastName': destinationLastName,
        'destinationEmail': destinationEmail,
        'destinationPhone': destinationPhone,
        'destinationSuburb': destinationSuburb,
        'destinationState': destinationState,
        'destinationPostcode': destinationPostcode,
        'destinationBuildingType': destinationBuildingType,
        'poBox': dropOffPOBox ? 'true' : 'false',
        'collectionDate': collectionDate,
        'pickupTimeWindow': pickupTimeWindow,
        'shipmentContents': parcelContent,
        'specialInstructions': specialInstructions,
        "insurance": insuranceValue,
        "authorityToLeave": authorityToLeave ? 'true' : 'false',
        "noLabels": noPrinter ? 'true' : 'false',
        'items': shipment_items,
        'additionalEmails': emails,
        order_id: orderId,
        currency: 'AUD',
        revenue: revenue,
        paypalEmail: paypalEmail,
        jobNumber: jobNumber,
        consignmentNumber: consignmentNumber,
      });
    } catch (e) {
      setStatus('error');
    }
  }, [history, orderId, revenue]);

  const onCancel = () => {
    setStatus('idle');
  };

  const onError = () => {
    setStatus('error');
    // setReCreateOrder(true);
  };

  const handleStripePayment = async (
    cardDetails: any,
    billing_details: any,
    stripe: any,
    elements: any,
    company_name: any
  ) => {
    if (isProcessingPayment) return;

    setIsProcessingPayment(true);
    setStatus('in-progress');

    try {
      const cardElement = elements.getElement("card");
      const result = await stripe.createToken(cardElement);

      if (result.error) {
        throw new Error(result.error.message);
      }

      await api.csrf();

      // When payment refactor is enabled, use the new async v1 endpoint
      if (PAYMENT_FLOW_V1_ENABLED) {
        const data = await api.patch<any>(`/v1/payment/order/${orderId}/stripe`, {
          card: result.token.id,
          email: billing_details.email,
          name: billing_details.name,
          company: company_name,
        });

        if (data?.error) {
          await swal({
            title: "Payment Error!",
            text: data.error.message || "Your card was declined. Please try a different payment method.",
            icon: "error",
            confirmButtonText: "Ok",
          } as any);
          setStatus('idle');
          setIsProcessingPayment(false);
          return;
        }

        // Async processing: booking continues in background
        if (data?.processing) {
          trackGTMPurchase('stripe');

          history.push(`/order-complete?ref=${orderId}&payment_type=2&async=1`);
          setStatus('idle');
          setIsProcessingPayment(false);
          return;
        }

        // Fallback: handle as a synchronous completion response similar to legacy flow
        const newUser = data.email ? btoa(JSON.stringify(data)) : '';
        const paypalEmail = data.paypalEmail ? data.paypalEmail : '';
        const jobNumber = data.jobNumber ? data.jobNumber : '';
        const consignmentNumber = data.consignmentNumber ? data.consignmentNumber : '';
        const labelPath = data.labelPath ? data.labelPath : '';
        const invoicePath = data.invoicePath ? data.invoicePath : '';

        history.push(`/order-complete?ref=${orderId}&new=${newUser}&label=${labelPath}&invoice=${invoicePath}&payment_type=2`);

        trackGTMPurchase('stripe');

        let shipment_items: any = await setItemsForMixpanelPurchaseEvent(items);
        mixpanel.track('Puchase', {
          'label': 'puchase',
          'platform_used': 'Website',
          'term_and_conditions': true,
          'payment_status': 'success',
          'payment_method': 'Stripe',
          'priceExcludingGst': quoteExcludingGstPrice,
          'priceIncludingGst': quotePrice,
          'insuranceCategory': quoteInsurance,
          'courierServiceName': courierServiceName,
          'pickupAddress1': pickupAddress1,
          'pickupAddress2': pickupAddress2,
          'pickupFirstName': pickupFirstName,
          'pickupLastName': pickupLastName,
          'pickupEmail': pickupEmail,
          'pickupPhone': pickupPhone,
          'pickupSuburb': pickupSuburb,
          'pickupState': pickupState,
          'pickupPostcode': pickupPostcode,
          'pickupBuildingType': pickupBuildingType,
          'destinationAddress1': destinationAddress1,
          'destinationAddress2': destinationAddress2,
          'destinationFirstName': destinationFirstName,
          'destinationLastName': destinationLastName,
          'destinationEmail': destinationEmail,
          'destinationPhone': destinationPhone,
          'destinationSuburb': destinationSuburb,
          'destinationState': destinationState,
          'destinationPostcode': destinationPostcode,
          'destinationBuildingType': destinationBuildingType,
          'poBox': dropOffPOBox ? 'true' : 'false',
          'collectionDate': collectionDate,
          'pickupTimeWindow': pickupTimeWindow,
          'shipmentContents': parcelContent,
          'specialInstructions': specialInstructions,
          "insurance": insuranceValue,
          "authorityToLeave": authorityToLeave ? 'true' : 'false',
          "noLabels": noPrinter ? 'true' : 'false',
          'items': shipment_items,
          'additionalEmails': emails,
          order_id: orderId,
          currency: 'AUD',
          revenue: revenue,
          paypalEmail: paypalEmail,
          jobNumber: jobNumber,
          consignmentNumber: consignmentNumber,
        });

        setStatus('idle');
        setIsProcessingPayment(false);
      } else {
        // Legacy flow
        const data = await api.patch<any>(`/order/${orderId}/2/payment`, {
          card: result.token.id,
          email: billing_details.email,
          name: billing_details.name,
          company: company_name,
        });

        if (data.meta && data.meta.payment_error === true) {
          await swal({
                      title: "Payment Error!",
                      text: data.meta.message,
                      icon: "error",
                      confirmButtonText: "Ok"
                  } as any);
          setStatus('idle');
          setIsProcessingPayment(false);
                  return;
        }
        if (!data || data.error) {
          setStatus('error');
        }

        await pay(data.client_secret, billing_details, cardDetails, stripe, elements, company_name);
      }
    } catch (error: any) {
      console.error('Stripe payment error:', error);

      // Check if it's a Stripe API error response
      if (error?.response?.data?.error) {
        const stripeError = error.response.data.error;
        await swal({
          title: "Payment Error!",
          text: stripeError.message || "Your card was declined. Please try a different payment method.",
          icon: "error",
          confirmButtonText: "Ok"
        } as any);
      } else if (error?.message) {
        // Handle other types of errors (like network errors)
        await swal({
          title: "Payment Error!",
          text: error.message,
          icon: "error",
          confirmButtonText: "Ok"
        } as any);
      } else {
        // Fallback to generic error
        setStatus('error');
        setIsProcessingPayment(false);
        return;
      }
      
      setStatus('idle');
      setIsProcessingPayment(false);
    }
  };

  //confirm payment
  const pay = async (
    clientSecret: string,
    billing_details: any,
    cardDetails: any,
    stripe: any,
    elements: any,
    company_name: string
  ) => {
    if (!stripe || !elements) {
      throw new Error("Stripe.js hasn't loaded yet");
    }

    const payload = await stripe.confirmCardPayment(clientSecret, {
      payment_method: {
        card: elements.getElement(CardElement),
        billing_details,
      },
    });

    if (payload.error) {
      setStatus('error');
    }

    if (payload.paymentIntent && payload.paymentIntent.status === 'succeeded') {
      try {
        await api.csrf();
        const response = await api.post<any>(`/order/${orderId}/2/paymentResponse`, {
          paymentResponse: payload.paymentIntent,
          company_name: company_name,
          email: billing_details.email
        });

        // Handle successful payment
        const newUser = response.email ? btoa(JSON.stringify(response)) : '';
        const paypalEmail = response.paypalEmail || '';
        const jobNumber = response.jobNumber || '';
        const consignmentNumber = response.consignmentNumber || '';
        const labelPath = response.labelPath || '';
        const invoicePath = response.invoicePath || '';

        history.push(`/order-complete?ref=${orderId}&new=${newUser}&label=${labelPath}&invoice=${invoicePath}&payment_type=2`);

          trackGTMPurchase('stripe');

          let shipment_items: any = await setItemsForMixpanelPurchaseEvent(items);
          //tracking purchase on mixpanel
          mixpanel.track('Puchase', {
            'label': 'puchase',
            'platform_used': 'Website',
            'term_and_conditions': true,
            'payment_status': 'success',
            'payment_method': 'Stripe',
            'priceExcludingGst': quoteExcludingGstPrice,
            'priceIncludingGst': quotePrice,
            'insuranceCategory': quoteInsurance,
            'courierServiceName': courierServiceName,
            'pickupAddress1': pickupAddress1,
            'pickupAddress2': pickupAddress2,
            'pickupFirstName': pickupFirstName,
            'pickupLastName': pickupLastName,
            'pickupEmail': pickupEmail,
            'pickupPhone': pickupPhone,
            'pickupSuburb': pickupSuburb,
            'pickupState': pickupState,
            'pickupPostcode': pickupPostcode,
            'pickupBuildingType': pickupBuildingType,
            'destinationAddress1': destinationAddress1,
            'destinationAddress2': destinationAddress2,
            'destinationFirstName': destinationFirstName,
            'destinationLastName': destinationLastName,
            'destinationEmail': destinationEmail,
            'destinationPhone': destinationPhone,
            'destinationSuburb': destinationSuburb,
            'destinationState': destinationState,
            'destinationPostcode': destinationPostcode,
            'destinationBuildingType': destinationBuildingType,
            'poBox': dropOffPOBox ? 'true' : 'false',
            'collectionDate': collectionDate,
            'pickupTimeWindow': pickupTimeWindow,
            'shipmentContents': parcelContent,
            'specialInstructions': specialInstructions,
            "insurance": insuranceValue,
            "authorityToLeave": authorityToLeave ? 'true' : 'false',
            "noLabels": noPrinter ? 'true' : 'false',
            'items': shipment_items,
            'additionalEmails': emails,
            order_id: orderId,
            currency: 'AUD',
            revenue: revenue,
            paypalEmail: paypalEmail,
            jobNumber: jobNumber,
            consignmentNumber: consignmentNumber,
          });

      } catch (error) {
        setStatus('error');
        setErrorMessage(`Payment was successful for your order reference <code>${orderId}</code>, but there was an error processing the order. Please contact support.`);
      }
    } else if (payload.error) {
  
      try{
        track('app-failed-payment', {
          failedPaymentEmail: billing_details.email,
          errorType: payload.error.code
        });
        await api.csrf();
        const response = await api.post<any>(`/order/${orderId}/2/paymentResponse`, {
          stripeError: true,
          message: payload.error.code,
          email: billing_details.email
        });

        if (payload.error.code) {
          let Modal: any = [];
          let Fade: any = [];
          Modal = document.getElementsByClassName('modal');
          Fade = document.getElementsByClassName('fade');

          let forms: any = [];
          let modalbody: any = [];
          let newDiv = document.createElement('span');
          forms = document.forms;
          modalbody = document.getElementsByClassName('modal-body');
          newDiv.className = `stripe-error`;
          newDiv.style.cssText = `color: ${BRAND_COLORS.primary};font-size: 12px;margin-bottom:10px;`;
          newDiv.innerText = `
            ${payload.error.message}
          `;
          setStatus('idle');
          Modal.item(0).style.zIndex = '1060';
          Fade.item(0).style.opacity = '0.5';
          forms[0]!.parentNode.insertBefore(newDiv, forms[0]);
          forms[0][4].removeAttribute("disabled");
          modalbody.item(0).style.paddingTop = '0px';

        } else {
          setStatus('error');
        }
      }catch (e){
        setStatus('error');
      }
    } else{
      setStatus('error');
    }
  };

  const handleCoinbasePopup = () => {
    setStatus('in-progress');
    (async () => {
      try {
        await api.csrf();
        const checkoutPageURL = await api.patch<any>(`/order/${orderId}/3/payment`, {});
        if (checkoutPageURL) {
          let coinbaseWindow = window.open(
            checkoutPageURL,
            '_blank',
            'toolbar=yes,scrollbars=yes,resizable=yes,top=300,left=400,width=500,height=800'
          );

          checkCoinbasePaymentStatus(coinbaseWindow);
        } else {
          setStatus('error');
          // setReCreateOrder(true);
        }
      } catch (e) {
        setStatus('error');
        // setReCreateOrder(true);
      }
    })();
  };

  const checkCoinbasePaymentStatus = async (coinbaseWindow: any) => {
    await api
      .patch<any>(`/order/${orderId}/4/payment`, {})
      .then((response) => {
        if (response.status == 1) {
          history.push(`/order-complete?coinbase=payment_initiated&currency=${response.currency}&ref=${orderId}`);
          return;
        } else if (coinbaseWindow.closed !== false && response.status == 1) {
          history.push(`/order-complete?coinbase=payment_initiated&currency=${response.currency}&ref=${orderId}`);
          return;
        } else if (coinbaseWindow.closed !== false && response.status == 0) {
          setStatus('idle');
          return;
        } else if (response.status == 0 && coinbaseWindow.closed == false) {
          checkCoinbasePaymentStatus(coinbaseWindow);
        }
      })
      .catch((error) => {
        coinbaseWindow.close();
        setStatus('error');
        // setReCreateOrder(true);
      });
  };

  const setItemsForMixpanelPurchaseEvent = (items: any) => {
    let shipment_packages: any = [];
    items.map((item: any) => {
      shipment_packages.push({
        height: item.height.toString(),
        length: item.length.toString(),
        type: item.type.toString(),
        weight: item.weight.toString(),
        width: item.width.toString(),
        quantity: item.width.toString(),
      });
    });
    return shipment_packages;
  }

  useEffect(() => {
    if (!orderId) {
      history.push('/package-details');
      return;
    }

    setCurrentStep(4);
  }, [history, orderId, setCurrentStep]);

  useEffect(() => {
    return () => {
      buttons().close();
    };
  }, []);

  return (
    <>
      {status !== 'error' && <Header />}
      <OverlaySpinner enabled={status === 'in-progress'} />
      <div className={styles.page}>
      <div className={styles.content}>

      <OrderSummary
        className={styles.orderSummary}
        packageDetailsEditEnabled={status !== 'error'}
        quoteEditEnabled={status !== 'error'}
        addressDetailsEditEnabled={status !== 'error'}
        variant="payment-package-card"
      />
      <section className={styles.paymentCard}>
        {status === 'error' ? (
          errorMessage !== null ? (
            <Alert className={styles.alert} type="warning">
              <p dangerouslySetInnerHTML={{ __html: errorMessage }}></p>
              <ul>
                {errors?.map((message, i) => (
                  <li key={i}>{message}</li>
                ))}
              </ul>
            </Alert>
          ) : (
            <Alert className={styles.alert} type="error">
              <p>There was an error processing your order. We have notified our tech team of the issue.</p>
              <p>
                If you would like to contact our support team, please reference this number: <code>{orderId}</code>
              </p>
            </Alert>
          )
        ) : (
          <div className={styles.buttonWrapper}>
          <div className={styles.secureCheckoutCard}>
            <div className={styles.secureHeader}>
              <span className={styles.secureIcon}>
                <FontAwesomeIcon icon={faShieldHalved} />
              </span>
              <div>
                <h4 className={styles.secureTitle}>
                  Secure Checkout{' '}
                  <span className={styles.secureLock}>
                    <FontAwesomeIcon icon={faLock} />
                  </span>
                </h4>
                <p className={styles.secureSubtext}>Your payment is encrypted.</p>
              </div>
            </div>
            <div className={styles.secureBody}>
          <Modal
            className={styles.paymentModal}
            show={show}
            onHide={isProcessingPayment ? ()=>{} : handleClose}
            animation={true}
            aria-labelledby="contained-modal-title-vcenter"
            centered
          >
            <Modal.Header
              className={styles.paymentModalHeader}
              closeButton
              onHide={isProcessingPayment ? () => {} : handleClose}
            >
              <Modal.Title>Pay with Credit Card</Modal.Title>
            </Modal.Header>
            <Modal.Body className={styles.paymentModalBody}>
              <Elements stripe={stripePromise}>
                <Stripe handleStripePayment={handleStripePayment} />
              </Elements>
            </Modal.Body>
            <Modal.Footer className={styles.paymentModalFooter}>
              <Button onClick={handleClose} className={styles.modalCloseButton} disabled={isProcessingPayment}>
                Close
              </Button>
            </Modal.Footer>
          </Modal>

          {(stripePaymentGateway || payPalPaymentGateway) && (
            <div className={styles.paymentOptionsRow}>
              {stripePaymentGateway && (
                <div className={styles.stripeButtonDiv}>
                  <div className="d-grid col-12 mx-auto">
                    <button
                      className={styles.checkoutPrimaryButton}
                      type="button"
                      onClick={handleShow}
                      disabled={isProcessingPayment}
                    >
                      <span className={styles.checkoutPrimaryText}>Pay ${revenue} with Debit or Credit</span>
                      <span className={styles.cardBrands}>VISA • Mastercard</span>
                    </button>
                  </div>
                </div>
              )}

              {payPalPaymentGateway == true && (
                <div className={styles.stripeParentDiv}>
                  <div className={styles.stripeChildDiv}>
                    <PayPalButton
                      createOrder={createOrder}
                      onApprove={onApprove}
                      onError={onError}
                      onCancel={onCancel}
                      style={paypalStyle}
                    />
                  </div>
                </div>
              )}
            </div>
          )}
          {/* {(payPalPaymentGateway == true && coinbasePaymentGateway == true) ||
            (stripePaymentGateway == true && coinbasePaymentGateway == true) ? (
            <div style={{ width: '100%' }}>
              <div className="text-center d-flex p-4 m-auto" style={{ width: '50%' }}>
                <hr className="flex-grow-1" />
                <span className="px-2 font-weight-lighter small align-self-center">or</span>
                <hr className="flex-grow-1" />
              </div>
            </div>
          ) : (
            ''
          )}
          {coinbasePaymentGateway == true && (
            <>
              <div className={styles.stripeButtonDiv}>
                <div className="d-grid gap-2 col-12 mx-auto">
                  <button className="btn" type="button" style={coinbaseCheckout} onClick={handleCoinbasePopup}>
                    Pay with Crypto{' '}
                    <img
                      src="https://assets.coingecko.com/coins/images/1/small/bitcoin.png"
                      alt="btc-logo"
                      height="28"
                      width="28"
                    />
                    <img
                      src="https://assets.coingecko.com/coins/images/279/small/ethereum.png"
                      alt="ethereum-logo"
                      height="28"
                      width="28"
                    />
                    <img
                      src="https://assets.coingecko.com/coins/images/5/small/dogecoin.png"
                      alt="dogecoin-logo"
                      height="28"
                      width="28"
                    />{' '}
                    <img
                      src="https://assets.coingecko.com/coins/images/2/small/litecoin.png"
                      alt="litecoin-logo"
                      height="28"
                      width="28"
                    />{' '}
                    <img
                      src="https://assets.coingecko.com/coins/images/6319/small/USD_Coin_icon.png"
                      alt="usdcoin-logo"
                      height="28"
                      width="28"
                    />
                  </button>
                </div>
              </div>
            </>
          )} */}
            </div>
          </div>
          </div>
        )}
      </section>
      </div>
      </div>
    </>
  );
}
